import {AnyAction} from "@reduxjs/toolkit";
import {
    APP_APPCODE_STORAGE_KEY,
    APP_INITIALIZED,
    APP_LOCALE_AVAILABLE_LOCALES,
    APP_LOCALE_FALLBACK,
    APP_LOCALE_STORAGE_KEY,
    APP_SET_API_URL_INFO,
    APP_SET_AUTHCODE_INFO,
    APP_SET_MODULE_INFO,
    APP_SET_SYSTEM_INFO,
    APP_UPDATE_PARAMAETER,
    CLOSE_SIDEBAR,
    GET_APP_DATA_SAGA,
    GET_APP_DATA_SUCCESS,
    OPEN_SIDEBAR,
    RESIZE_WINDOW,
    TOGGLE_SIDEBAR,
    APP_LOCALE_CHANGE_SAGA
} from "@/Redux/App/AppConstants";
import {RootStateOrAny} from "react-redux";
import _ from "lodash";
import {LogLevel} from "@/Logger";

interface AppState {
    initialized: boolean;
    isInitializing: boolean;
    mandant: object;
    translations: any;
    languages: object;
    sidebarIsOpen: boolean;
    contentWidth: number;
    vehicleGroups: any;
    categories: any;
    equipments: any;
    legend: any;
    regions: any;
    paymentConditions: any;
    countries: any;
    pricelists: any;
    dataInitialized: boolean;
    dataIsInitialitzing: boolean;
    modules: any;
    stations: any;
    viewData: any;
    paymentMethods: any;
    initializeIsFailed: boolean;
    version: string;
    userQueries: any;
    queries: any;
    apiUrl: string;
    theme: string;
    parameters: any;
    colors: any;
    texts: any;
    rights: any;
    damageStates: any;
    taxKeys: any;
    appCode: string | null;
    rates: any;
    locale: any;
}

const initialState: AppState = {
    initialized: false,
    isInitializing: false,
    mandant: {},
    translations: null,
    languages: {},
    sidebarIsOpen: true,
    contentWidth: 0,
    vehicleGroups: {
        timestamp: null,
        data: null,
    },
    categories: {
        timestamp: null,
        data: null,
    },
    equipments: {
        timestamp: null,
        data: null,
    },
    legend: {
        timestamp: null,
        data: null,
    },
    regions: {
        timestamp: null,
        data: null,
    },
    modules: {
        timestamp: null,
        data: null,
    },
    stations: {
        timestamp: null,
        data: null,
    },
    paymentConditions: {
        timestamp: null,
        data: null,
    },
    countries: {
        timestamp: null,
        data: null,
    },
    pricelists: {
        timestamp: null,
        data: null,
    },
    groupAttributes: {
        timestamp: null,
        data: null,
    },
    userQueries: {
        timestamp: null,
        data: null,
    },
    queries: {
        timestamp: null,
        data: null,
    },
    dataInitialized: false,
    dataIsInitialitzing: false,
    viewData: null,
    paymentMethods: {
        timestamp: null,
        data: null,
    },
    initializeIsFailed: false,
    version: "",
    apiUrl: "",
    theme: "light",
    parameters: {
        timestamp: null,
        data: null,
    },
    colors: {
        timestamp: null,
        data: null,
    },
    texts: {
        timestamp: null,
        data: null,
    },
    rights: {
        timestamp: null,
        data: null,
    },
    damageStates: {
        timestamp: null,
        data: null,
    },
    taxKeys: {
        timestamp: null,
        data: null,
    },
    appCode: null,
    rates: {
        data: null
    },
    locale: localStorage.getItem(APP_LOCALE_STORAGE_KEY),
};

export default function AppReducer(state = initialState, action: AnyAction) {
    switch (action.type) {
        case "APP_RESET":
            return initialState;
        case APP_INITIALIZED:
            return {
                ...state,
                initialized: true,
            };
        case APP_SET_SYSTEM_INFO:
            return {
                ...state,
                version: action.payload.serverVersion,
                modules: action.payload.modules,
                mandant: action.payload.mandant,
            };
        case APP_SET_AUTHCODE_INFO:
            localStorage.setItem(
                APP_APPCODE_STORAGE_KEY,
                action.payload.appCode,
            );
            return {
                ...state,
                appCode: action.payload.appCode,
            };
        case APP_SET_API_URL_INFO:
            localStorage.setItem("apiUrl", action.payload.apiUrl);
            return {
                ...state,
                apiUrl: action.payload.apiUrl,
            };
        case TOGGLE_SIDEBAR:
            return {
                ...state,
                sidebarIsOpen: action.data.open,
                contentWidth: action.data.contentWidth,
            };
        case OPEN_SIDEBAR:
            return {...state};
        case CLOSE_SIDEBAR:
            return {...state};
        case RESIZE_WINDOW: {
            return {...state, contentWidth: action.data.contentWidth};
        }
        case GET_APP_DATA_SAGA:
            return {
                ...state,
                dataIsInitialitzing: true,
            };
        case GET_APP_DATA_SUCCESS:
            return {
                ...state,
                dataIsInitialitzing: false,
                vehicleGroups: {
                    data: action.data.vehicleGroupList.vehicleGroups,
                    timestamp: new Date().getTime(),
                },
                categories: {
                    data: action.data.categoryList.categories,
                    timestamp: new Date().getTime(),
                },
                userQueries: {
                    data: action.data.userQueryList.queries,
                },
                equipments: {
                    data: action.data.equipmentList?.equipments,
                    timestamp: new Date().getTime(),
                },
                legend: {
                    data: action.data.legendList?.legends,
                    timestamp: new Date().getTime(),
                },
                regions: {
                    data: action.data.regionList?.regions,
                    timestamp: new Date().getTime(),
                },
                stations: {
                    data: action.data.stationList?.stations,
                    timestamp: new Date().getTime(),
                },
                paymentMethods: {
                    data: action.data.paymentMethodList?.paymentMethods,
                    timestamp: new Date().getTime(),
                },
                countries: {
                    data: action.data.countryList?.countries,
                    timestamp: new Date().getTime(),
                },
                documentType: {
                    data: action.data.documentTypeList?.documentType,
                    timestamp: new Date().getTime(),
                },
                pricelists: {
                    data: action.data.pricelistList?.pricelists,
                    timestamp: new Date().getTime(),
                },
                parameters: {
                    data: action.data.parameterList?.parameters,
                    timestamp: new Date().getTime(),
                },
                colors: {
                    data: action.data.colorList?.colors,
                    timestamp: new Date().getTime(),
                },
                texts: {
                    data: action.data.textList?.texts,
                    timestamp: new Date().getTime(),
                },
                queries: {
                    data: action.data.queryList?.queries,
                    timestamp: new Date().getTime(),
                },
                rights: {
                    data: action.data.rightList?.rights,
                    timestamp: new Date().getTime(),
                },
                damageStates: {
                    data: action.data.damageStateList?.damageStates,
                    timestamp: new Date().getTime(),
                },
                users: {
                    data: action.data.userList?.users,
                    timestamp: new Date().getTime(),
                },
                rateUnits: {
                    data: action.data.rateUnitList?.rateUnits,
                },
                rates: {
                    data: action.data.rateList?.rates,
                },
                taxKeys: {
                    data: action.data.taxKeyList?.taxKeys,
                },
                mandant: {
                    data: action.data.mandant,
                },
                dataInitialized: true,
                viewData: action.data.viewData,
                translations: action.data.translations,
            };
        case APP_SET_MODULE_INFO:
            return {
                ...state,
                modules: action.payload.modules,
            };
        case APP_UPDATE_PARAMAETER: {
            return {
                ...state,
                parameters: {
                    data: action.data.parameters,
                    timestamp: new Date().getTime(),
                },
            };
        }
        case APP_LOCALE_CHANGE_SAGA:
            return {
                ...state,
                locale: action.payload,
            };
        default:
            return state;
    }
}

export const getEnvironment = (): string => {
    let environment = "production";

    if (_.includes(getBaseUrl(), "acc")) {
        environment = "staging";
    }
    if (
        _.includes(getBaseUrl(), "localhost") ||
        _.includes(getBaseUrl(), "172.16.") ||
        _.includes(getBaseUrl(), "192.168.") ||
        _.includes(getBaseUrl(), "127.0.0.1")
    ) {
        environment = "development";
    }

    if (!_.isEmpty(localStorage.getItem("environment"))) {
        // @ts-ignore
        environment = localStorage.getItem("environment");
    }

    return environment;
};

export const getLogLevel = (): LogLevel => {
    let loglevel: LogLevel = "warn";

    if (!_.isEmpty(localStorage.getItem("APP_LOG_LEVEL"))) {
        // @ts-ignore
        loglevel = localStorage.getItem("APP_LOG_LEVEL");
    }

    return loglevel;
};

export const getLocale = (): string => {
    let locale: string | null = localStorage.getItem(APP_LOCALE_STORAGE_KEY);
    if (locale === null) {
        try {
            const lang = navigator.language.split("-")[0];
            if (APP_LOCALE_AVAILABLE_LOCALES.includes(lang)) {
                locale = lang;
            } else {
                throw new Error();
            }
        } catch (e) {
            locale = APP_LOCALE_FALLBACK;
        }

        localStorage.setItem(APP_LOCALE_STORAGE_KEY, locale);
        return getLocale();
    }
    return locale;
};

export const getAppCode = (): string => {
    // @ts-ignore
    return window?.globalConfig?.authcode || import.meta.env.VITE_AUTHCODE;

    //return localStorage.getItem(APP_APPCODE_STORAGE_KEY) || "";
    /*const environment = getEnvironment();

    if (environment === 'development') {
        if (import.meta.env.VITE_AUTHCODE === undefined) {
            throw Error('authcode is not defined');
        }
        return import.meta.env.VITE_AUTHCODE;
    }

    const url = getBaseUrl();
    const urlParts = url.split('.');
    const subdomain = urlParts[0].split('-');
    const code = subdomain[0];
    const version = subdomain[1];
    let appCode = code;

    if (!_.isEmpty(version)) {
        appCode += '/' + version.toUpperCase();
    }

    return appCode;*/
};

export const getState = (state: RootStateOrAny) => {
    if (typeof state.app === "object") {
        return state.app;
    }
    return state;
};

export const getApiUrl = () => {
    const environment = getEnvironment();

    let version = import.meta.env.VITE_VERSION;
    if (version === undefined) {
        throw Error("app version is not defined");
    }
    if (version !== "master") {
        const splitted = version.split(".");
        splitted.splice(3, 1);

        version = splitted.join(".");
    }

    switch (environment) {
        case "development":
            return import.meta.env.VITE_API_URL;
        default:
            return localStorage.getItem("apiUrl");
    }
};

export const getBaseUrl = () => {
    return window.location.host;
};

export const selectAppIsInitialized = (state: RootStateOrAny) => {
    return getState(state).initialized;
};

export const selectTheme = (state: RootStateOrAny) => {
    if (localStorage.getItem("APP_THEME")) {
        return localStorage.getItem("APP_THEME");
    }
    return getState(state).theme;
};

export const selectContentWitdh = (state: RootStateOrAny) => {
    return getState(state).contentWidth;
};

export const selectSocketHostUrl = (state: RootStateOrAny) => {
    return getState(state).socketBaseUrl;
};

export const selectDataIsInitialized = (state: RootStateOrAny) => {
    return getState(state).dataInitialized;
};

export const selectModules = (state: RootStateOrAny) => {
    return getState(state).modules;
};

export const selectStations = (state: RootStateOrAny) => {
    return getState(state).stations;
};

export const selectVehicleGroups = (state: RootStateOrAny) => {
    return getState(state).vehicleGroups;
};

export const selectRegions = (state: RootStateOrAny) => {
    return getState(state).regions;
};

export const selectCategories = (state: RootStateOrAny) => {
    return getState(state).categories;
};

export const selectSidebarIsOpen = (state: RootStateOrAny) => {
    return getState(state).sidebarIsOpen;
};

export const selectMandant = (state: RootStateOrAny) => {
    return getState(state).mandant.data;
};

export const selectParameters = (state: RootStateOrAny) => {
    return getState(state).parameters;
};

export const selectColors = (state: RootStateOrAny) => {
    return getState(state).colors;
};

export const selectTaxKeys = (state: RootStateOrAny) => {
    return getState(state).taxKeys;
};

export const selectAppCode = (state: RootStateOrAny) => {
    return getAppCode();
};

export const selectState = (state: RootStateOrAny) => {
    return getState(state);
};

export const selectServerVersion = (state: RootStateOrAny) => {
    return getState(state).version;
};

export const selectLocale = (state: RootStateOrAny) => {
    return getState(state).locale;
};